/**
 * Navigating never ends a call silently (job #46, Tom 2026-09-24). The bottom
 * nav stays reachable during a live call or games night, so a tap on it could
 * unmount the call — and unmounting ends it for both people. A page in a call
 * registers `guardLeave`; any navigation away while it is live waits on the
 * one confirm sheet that RoutedBottomNav renders, and goes only on "Leave".
 * The page's own Leave button ends the call first, so it is never asked twice.
 */
import { ref } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'

export type LeaveKind = 'call' | 'games'

interface Ask { kind: LeaveKind; resolve: (go: boolean) => void }

export const leaveAsk = ref<Ask | null>(null)

export function confirmLeave(kind: LeaveKind): Promise<boolean> {
  // A second navigation while the sheet is up answers the first "stay".
  leaveAsk.value?.resolve(false)
  return new Promise<boolean>((resolve) => { leaveAsk.value = { kind, resolve } })
}

export function answerLeave(go: boolean): void {
  const a = leaveAsk.value
  leaveAsk.value = null
  a?.resolve(go)
}

export function guardLeave(isLive: () => boolean, kind: LeaveKind): void {
  onBeforeRouteLeave(() => (isLive() ? confirmLeave(kind) : true))
}
